export default "__VITE_ASSET__CzzWNAqJ__"